import { pipe } from '$tablet-app/src/app/utils/composition';
import { AppRecord } from '../types';
import filterAppsByCategories from './filterAppsByCategories';
import filterAppsByText from './filterAppsByText';

interface Params {
  apps: AppRecord[];
  text?: string;
  categories?: string[];
}

/** Filters apps using the field on the app screen */
const filterAppsOnAppScreen = ({
  apps,
  text,
  categories,
}: Params): AppRecord[] =>
  pipe(filterAppsByText(text), filterAppsByCategories(categories))(apps);

export default filterAppsOnAppScreen;
